// client\src\components\Usuarios\CreateCliente.jsx


import styles from '../../../../client/src/App.module.css';
import { fonteLeads } from '../../../../client/src/components/equipeagiliza';
import { useState, useEffect } from 'react';
import { NotificationManager } from 'react-notifications';
import api from '../../../../client/src/api/axios';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { FaUserPlus, FaPencilAlt } from 'react-icons/fa';


// Chame essa função uma vez para inicializar a fila


// Helper functions for CPF validation and formatting
const formatCpf = (cpf) =>
  cpf
    .replace(/\D/g, '') // Remove non-numeric characters
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

const unformatCpf = (cpf) => cpf.replace(/\D/g, '');

// CPF Validation Function
const validateCpf = (cpf) => {
  if (!cpf) {
    return true
  }
  // Remove caracteres não numéricos
  const unformattedCpf = cpf.replace(/\D/g, '');

  // Verifica se o CPF possui 11 dígitos ou se todos os dígitos são iguais
  if (unformattedCpf.length !== 11 || /^(\d)\1+$/.test(unformattedCpf)) {
    return false;
  }

  // Função para calcular o dígito verificador
  const calcDigit = (base, factor) => {
    let total = 0;
    for (let i = 0; i < base.length; i++) {
      total += parseInt(base[i]) * factor--;
    }
    const remainder = total % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  // Calcula os dígitos verificadores
  const baseCpf = unformattedCpf.slice(0, 9);
  const firstDigit = calcDigit(baseCpf, 10);
  const secondDigit = calcDigit(baseCpf + firstDigit, 11);

  // Verifica se os dígitos calculados conferem com os do CPF
  return firstDigit === parseInt(unformattedCpf[9]) && secondDigit === parseInt(unformattedCpf[10]);
};



export default function CreateCliente({ clientesList, handleToggleShowAll, showAllClientes, parceirosList, clearDataClienteAux, onClienteSelecionado, onClienteCriado, errorCliente, selectedId, }) {

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [nomeCliente, setNomeCliente] = useState("");
  const [contatoCliente, setContatoCliente] = useState("");
  const [cpfCliente, setCpfCliente] = useState("");
  const [errorCpf, setErrorCpf] = useState("");
  const [parceiroCliente, setParceiroCliente] = useState("");
  const [inicioCliente, setInicioCliente] = useState(getCurrentDate());
  const [historico, setHistorico] = useState({});
  // const [clienteSelecionado, setClienteSelecionado] = useState("");
  const [editandoCliente, setEditandoCliente] = useState(false);
  const [newParceiro, setNewParceiro] = useState("");
  const [hiddenCliente, setHiddenCliente] = useState(false);
  const [filterCliente, setFilterCliente] = useState('');
  const [notificationType, setNotificationType] = useState(0);

  const [showForm, setShowForm] = useState(false);


  const [listaFontes, setListaFontes] = useState([]);



  // já existe:
  const [clienteSelecionado, setClienteSelecionado] = useState("");

  // >>> SINCRONIZAÇÃO COM selectedId <<<
  useEffect(() => {
    // aceita string/number; normaliza p/ number (se possível)
    if (selectedId !== undefined && selectedId !== null && selectedId !== "") {
      const coerced = Number(selectedId) || selectedId;
      setClienteSelecionado(coerced);

      // opcional (mas recomendado): avisa o pai
      if (onClienteSelecionado) {
        onClienteSelecionado(coerced);
      }
    }
  }, [selectedId]); // dispara quando o pai muda o selectedId


  // 1) FILTRAR por nome (case/acentos-insensível)
  useEffect(() => {
    // evita sobrescrever o estado especial logo após cadastrar
    if (filterCliente === 'Cliente Cadastrado!') return;

    // quando pediu "Ver todos"
    if (showAllClientes) {
      setFilteredCliente(clientesList);
      return;
    }

    const term = filterCliente.trim();
    if (!term) {
      // sem filtro: não mostra nada (ou só o selecionado — o efeito abaixo cuida disso)
      setFilteredCliente([]);
      return;
    }

    const norm = (s) =>
      (s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    const t = norm(term);
    const filtered = clientesList.filter(c => norm(c.Nome).includes(t));
    setFilteredCliente(filtered);
  }, [filterCliente, clientesList, showAllClientes]);

  // 2) MOSTRAR o card do cliente selecionado mesmo sem filtro
  useEffect(() => {
    if (!clienteSelecionado) return;
    if (filterCliente || showAllClientes) return; // deixa o efeito de cima mandar

    const sel = clientesList.find(c => Number(c.id) === Number(clienteSelecionado));
    if (sel) setFilteredCliente([sel]);
  }, [clienteSelecionado, clientesList, filterCliente, showAllClientes]);






  useEffect(() => {
    async function carregarFontes() {
      try {
        const response = await api.get("/fonteLeads"); // rota já criada
        setListaFontes(response.data);
      } catch (err) {
        console.error("Erro ao carregar fontes de leads", err);
      }
    }
    carregarFontes();
  }, []);

  const insertDataCliente = async () => {
    if (!validateCpf(cpfCliente)) {
      setErrorCpf("CPF inválido. Verifique o número inserido.");
      return;
    }

    setErrorCpf(""); // Clear errors if validation passes

    try {
      const res = await api.post('/createCliente', {
        nomeCliente,
        contatoCliente,
        cpfCliente: unformatCpf(cpfCliente),
        parceiroCliente,
        inicioCliente,
        historico: JSON.stringify(historico),
        fonte: parseInt(newParceiro),
      });
      console.log('Response:', res.data); // Adicione esta linha para depuração      

      if (res.data.status) {
        NotificationManager.success('Cliente cadastrado com sucesso!', 'Cadastrado', 3000);

        const newCliente = {
          id: res.data.insertId,
          Nome: nomeCliente,
          contato: contatoCliente,
          cpf: cpfCliente,
        };

        // Atualiza a lista filtrada para mostrar apenas o novo cliente
        setFilterCliente("Cliente Cadastrado!")
        setFilteredCliente([newCliente]);
        console.log("setFilteredCliente")
        console.log(newCliente)

        // Notifica o componente pai sobre o novo cliente
        if (onClienteCriado) {
          console.log("onClienteCriado");
          onClienteCriado(newCliente);
        }

        // Seleciona o cliente recém-criado
        setClienteSelecionado(newCliente.id);


        // Limpa os campos do formulário
        setNomeCliente("");
        setContatoCliente("");
        setCpfCliente("");
      } else {
        NotificationManager.error('Erro ao cadastrar cliente. Tente novamente.', 'Erro', 3000);
      }
    } catch (err) {
      console.error(err);
      NotificationManager.error('Erro ao conectar ao servidor.', 'Erro', 3000);
    }
  };




  const updateCliente = async () => {
    if (validateFormCliente() === true) {
      try {
        const res = await api.post(`/updateCliente`, {
          id: clienteSelecionado,
          nomeCliente,
          contatoCliente,
          cpfCliente,
          parceiroCliente,
          inicioCliente,
          historico: JSON.stringify(historico),
          fonte: parseInt(newParceiro), // Adicionar a fonte como inteiro aqui
        });
        console.log('Response:', res.data); // Adicione esta linha para depuração
        if (res.data === true) {
          setNotificationType(8);
          clearDataCliente();
          setEditandoCliente(false);
        } else {
          setNotificationType(9);
        }
      } catch (error) {
        console.error('Erro ao atualizar o cliente:', error);
        setNotificationType(9);
      }
    } else {
      setNotificationType(10);
    }
  };



  useEffect(() => {
    if (notificationType === 1) {
      setNotificationType(0);
      return NotificationManager.success('Cliente cadastrado com sucesso!', 'Cadastrado', 3000);
    } else if (notificationType === 2) {
      setNotificationType(0);
      return NotificationManager.error('Ocorreu um erro ao cadastrar, cheque se as informações estão corretas!', 'Erro ao Cadastrar', 3000);
    } else if (notificationType === 3) {
      setNotificationType(0);
      return NotificationManager.warning('Você deve preencher todos os campos para cadastrar!', 'Campos Vazios', 3000);
    } else if (notificationType === 8) {
      setNotificationType(0);
      return NotificationManager.success('Os dados foram atualizados com sucesso!', 'Atualizado', 3000);
    } else if (notificationType === 9) {
      setNotificationType(0);
      return NotificationManager.error('Não foi possível atualizar os dados do usuário, entre em contato com o desenvolvedor!', 'Erro ao Atualizar', 3000);
    } else if (notificationType === 10) {
      setNotificationType(0);
      return NotificationManager.warning('Você deve preencher todos os campos para editar!', 'Campos Vazios', 3000);
    }
  }, [notificationType]);

  const hidden = {
    display: 'none'
  };

  const [filteredCliente, setFilteredCliente] = useState([]);

  const validateFormCliente = () => {
    if (nomeCliente === "" || contatoCliente === "") {
      return false;
    }
    return true;
  };

  const clearDataCliente = () => {
    setNomeCliente("");
    setContatoCliente("");
    setCpfCliente("");
    setParceiroCliente('');
    setInicioCliente('');
    setHistorico({});
  };

  // Mostra o card do cliente selecionado mesmo sem filtro
  useEffect(() => {
    if (!clienteSelecionado) return;
    if (filterCliente || showAllClientes) return;

    const sel = clientesList.find(c => Number(c.id) === Number(clienteSelecionado));
    if (sel) setFilteredCliente([sel]);
  }, [clienteSelecionado, clientesList, filterCliente, showAllClientes]);


  const shouldShowList =
    filteredCliente.length > 0 || showAllClientes || filterCliente !== '';




  const handleClienteClick = (user) => {
    const isSelected = user.id === clienteSelecionado;
    const newClienteSelecionado = isSelected ? null : user.id;
    setClienteSelecionado(newClienteSelecionado);
    if (onClienteSelecionado) {
      onClienteSelecionado(newClienteSelecionado);
    }
  };

  const handleEditClick = (user) => {
    setClienteSelecionado(user.id);
    setNomeCliente(user.Nome);
    setContatoCliente(user.contato);
    setCpfCliente(user.cpf);
    setParceiroCliente(user.parceiro);
    setInicioCliente(user.inicio.split('T')[0]);
    setHistorico(user.historico);
    if (user.fonte) {
      setNewParceiro(user.fonte.toString());
    }
    setEditandoCliente(true);
    setShowForm(true);
  };

  // handler para abrir/fechar o form
  const handleCadastrarNovoCliente = () => {
    setShowForm(prev => {
      const next = !prev;
      if (next) {
        // abrindo: zera estado e garante que não está em edição
        setEditandoCliente(false);
        clearDataCliente();
      }
      return next;
    });
    // se você usava hiddenCliente para algo visual, pode manter:
    // setHiddenCliente(prev => !prev);
  };




  return (
    <div className={styles.hundred} style={{}}>
      <div className={styles.containerTituloInputPesquisa}>
        <div style={{ display: 'flex', alignItems: 'center' }}>


          <input
            className={`${styles.inputStyle} ${styles.inputFilter} ${errorCliente ? styles.errorBorder : ''}`}
            type="text"
            onChange={(e) => setFilterCliente(e.target.value)}
            value={filterCliente}
            placeholder="Digite o nome do cliente"
          />
          {errorCliente && (
            <div style={{ color: 'red', marginTop: '5px', fontSize: '0.8rem' }}>
              selecione
            </div>
          )}


          {/* <span
            style={{ marginLeft: '10px', cursor: 'pointer', color: 'blue', fontSize: '0.8rem' }}
            onClick={handleToggleShowAll}
          >
            {showAllClientes ? 'Ocultar' : 'VerTodos'}
          </span> */}
        </div>
      </div>
      <div style={shouldShowList ? { marginBottom: "15px" } : { display: 'none' }} className={styles.clientesPesquisa}>
        {filteredCliente.map((user) => {
          const isSelected = Number(user.id) === Number(clienteSelecionado);  
          return (
            <div
              id={`cli-${user.id}`}
              key={user.id}
              className={`${styles.userCliente} ${isSelected ? styles.clienteSelected : ''}`}
              onClick={() => handleClienteClick(user)}
              style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
            >
              <div className={styles.createClienteNome}>
                <p>{user.Nome}</p>
                <FaPencilAlt
                  style={{ cursor: 'pointer', marginLeft: 10, position: "absolute", right: 5, left: "auto" }}
                  onClick={(e) => { e.stopPropagation(); handleEditClick(user); }}
                />
              </div>
              <div className={styles.userContainer1} style={{ padding: 10 }}>
                <p>{user.cpf} - {user.contato}</p>
                <p>{user.historico}</p>
              </div>
            </div>
          );
        })}

      </div>

      <div className={`${styles.centerText} ${styles.cadastroClienteButton} ${styles.cadastroClienteButtonBig}`}>

        {/* {`${} ${} ${}`} */}
        <button
          type="button"
          onClick={handleCadastrarNovoCliente}
          style={{
            padding: "10px",
            borderRadius: "20px",
            backgroundColor: showForm ? "#8B0000" : "var(--corPrimaria)", // vermelho escuro quando aberto
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: "bold",
            border: "none",
            cursor: "pointer"
          }}
        >
          <FaUserPlus size={18} />
          <span>{showForm ? "Fechar" : "Cadastrar novo cliente"}</span>
        </button>
      </div>



      {showForm && (
        <div className={styles.containerTituloInputPesquisa} style={{ padding: "10px", backgroundColor: "var(--brancoCC)", gap: "10px" }}>
          {/* <h2>{editandoCliente ? 'Editar Cliente' : 'Cadastrar Cliente'}</h2> */}
          <input
            className={styles.inputStyleLogin}
            type="text"
            onChange={(e) => setNomeCliente(e.target.value)}
            value={nomeCliente}
            placeholder="Nome do cliente:"
          />
          <PhoneInput
            country={'br'}
            value={contatoCliente}
            onChange={(phone) => setContatoCliente(phone)}
            inputStyle={{ width: '100%' }}
            placeholder="Digite o contato"
            inputProps={{
              name: 'phone',
              required: true,
              autoFocus: true
            }}
          />
          <input
            className={`${styles.inputStyle} ${errorCpf ? styles.errorInput : ''}`}
            type="text"
            placeholder="CPF (000.000.000-00)"
            maxLength={14} // Limit input to 14 characters (formatted CPF)
            value={formatCpf(cpfCliente)}
            onChange={(e) => {
              const formattedCpf = formatCpf(e.target.value);
              if (formattedCpf.length <= 14) setCpfCliente(formattedCpf);
              setErrorCpf(""); // Clear errors while editing
            }}
          />
          {errorCpf && <span className={styles.errorMessage}>{errorCpf}</span>}
          <div>
            <div className={styles.containerVendedor}>
              <p className={styles.inputText}>FONTE DO LEAD: </p>

              <select
                className={styles.inputStyleVendedor}
                value={newParceiro}
                onChange={(e) => {
                  console.log('📌 Fonte selecionada:', e.target.value);
                  setNewParceiro(e.target.value);
                }}
              >
                <option value="">Selecione a fonte</option>
                {listaFontes.map((fonte) => (
                  <option key={fonte.id} value={fonte.id}>
                    {fonte.nome}
                  </option>
                ))}
              </select>






            </div>
            <div
              style={newParceiro === "1" ? {} : hidden}
              className={styles.containerVendedor2}
            >
              <p className={styles.inputText}>PARCEIRO RESPONSAVEL: </p>
              <select
                className={styles.inputStyleVendedor}
                name=""
                id=""
                value={parceiroCliente}
                onChange={(e) => {
                  console.log('📌 Parceiro selecionado:', e.target.value);
                  setParceiroCliente(e.target.value)
                }}
              >
                <option value="">Selecione um parceiro</option>
                {parceirosList.map(items => (
                  <option key={items.usuarioParceiro} value={items.id}>{items.usuarioParceiro}</option>
                ))}


              </select>
            </div>
          </div>
          <div>
            <p className={styles.inputText}>PRIMEIRO CONTATO:</p>
            <input type="date" value={inicioCliente} onChange={(e) => setInicioCliente(e.target.value)} required />
          </div>
          <div className={`${styles.centralizar} ${styles.topMargin10}`}>
            <button onClick={() => { editandoCliente ? updateCliente() : insertDataCliente(); }} className={styles.cadastroCliente}>
              {editandoCliente ? 'ATUALIZAR' : 'CADASTRAR'}
            </button>
          </div>
        </div>
      )}



      <div className={styles.divisor}></div>
    </div>
  );
}
